import {css} from "@emotion/css";

export const styles = {
  root: css`
    display: flex;
    width: 100%;
    text-decoration: none;
  `,
};
